import React, { useState, useEffect, useRef } from 'react';
import {
  Background,
  Content,
  Header,
  Icon,
  Button,
  CancelButton,
  ButtonDiv,
  FormDiv,
  UploadButton,
} from './styles';
import { FaTimes } from 'react-icons/fa';
import InputComponent from '../../Input';
import TextAreaComponent from '../../TextArea';
import { navigationUrl } from '../../../store/analytic/actions';
import { useDispatch, useSelector } from 'react-redux';
import { claimPayment } from '../../../store/contract/actions';
import moment from "moment";
import { InputType } from 'zlib';
import { toast } from 'react-toastify';
import Toast from '../../Toast';

interface IModal {
  contracts: string[],
  databaseId: number,
  handlerClose: () => void;
}

function ClaimPayment({ contracts, databaseId, handlerClose }: IModal) {
  const dispatch = useDispatch();
  const [date, setDate] = useState('');
  const [dateError, setDateError] = useState(false);
  const inputFile = useRef<HTMLInputElement>(null);
  const [obsError, setObsError] = useState(false);
  const [obs, setObs] = useState('');
  const [base64, setBase64] = useState('');
  const [fileExt, setFileExt] = useState('');
  const [fileName, setFileName] = useState('');
  const requestOk = useSelector(
    (state: ApplicationState) => state.contract.requestOk,
  );

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/abreAlegaPagamento',
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (requestOk) {
      toast.error(
        <Toast title={'Alegar Pagamento'} description={'Solicitação enviada com sucesso'} type={"success"} />
      );
      dispatch(claimPayment.failure(""));
      handlerClose();
    }
  }, [dispatch, requestOk]);

  const handler = (e: any) => {
    e.target.id === 'background' && handlerClose();
  };

  const handleDateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value);
  };

  const handleDateExit = () => {
    setDateError(date === '');
  };

  const handleObsValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setObs(e.target.value);
  };

  const handleObsExit = () => {
    setObsError(obs === '');
  };

  const handlerEnviar = () => {
    dispatch(claimPayment.request({ 
      contracts,
      base64,
      description: obs,
      fileExtension: fileExt,
      paymentDate: moment(date).toDate(),
      databaseId
    }));
  };

  const handleClickUpload = () => {
    inputFile!.current!.value = "";
    inputFile!.current!.click();
  };

  const handleChangeInputFile = (event: any) => {
    if (event!.target.files.length > 0) {
      if (!isValid(event.target.files[0].name)) {
        toast.error(
          <Toast title={'Arquivo inválido'} description={'Por favor, selecione um arquivo .jpg, .jpeg, .png ou .pdf'}  />
        );
        return;
      }
      setFileExt(getExtension(event.target.files[0].name))
      setFileName(event.target.files[0].name)
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        setBase64(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const getFormatedFileName = () => {
    return fileName.length > 24 ? fileName.slice(0, 10).concat("...", fileName.slice(-12)) : fileName;
  }

  const getExtension = (filename: string) => {
    var parts = filename.split('.');
    return parts[parts.length - 1];
  }
  
  const isValid = (filename: string) => {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'pdf':
      case 'png':
        return true;
    }
    return false;
  }

  return (
    <Background id='background' onClick={(e) => handler(e)}>
      <Content>
        <Header>
          <div className='close' onClick={handlerClose}>
            Fechar
          </div>
          <div className='title'>Alegar pagamento</div>
          <div className='ghost' />
          <Icon onClick={handlerClose}>
            <FaTimes style={{ height: 18, width: 16 }} />
          </Icon>
        </Header>
        <FormDiv>
          <div className={'format'}>
            <div className={'default2'}>
              <span>Data do pagamento:</span>
              <InputComponent
                value={date}
                max={moment().format("YYYY-MM-DD")}
                handlerOnchange={handleDateValue}
                error={dateError}
                type={'date'}
                errorMessage={'Data inválida'}
                height={'48px'}
                onBlur={handleDateExit}
              />
            </div>

            <div className={'default'}>
              <span>Comprovante (não obrigatório):</span>
              <div className={'fileDiv'}>
                <input
                    type="file"
                    id="file"
                    ref={inputFile}
                    style={{ display: "none" }}
                    onChange={handleChangeInputFile}
                    accept=".jpg,.jpeg,.png,.pdf"
                />
                <UploadButton onClick={handleClickUpload}>Escolher arquivo</UploadButton>
                <div className={'file'}>{base64 ? getFormatedFileName() : "Nenhum arquivo selecionado"}</div>
              </div>
              <span className='obs'>Anexe uma imagem JPG, PNG ou um PDF</span>
              <br />
            </div>

            <div>
              <span>Observações:</span>
              <br />
              <TextAreaComponent
                handlerOnchange={handleObsValue}
                error={obsError}
                errorMessage={'Preencha as observações'}
                height={'100px'}
                value={obs}
                onBlur={handleObsExit}
              />
            </div>
          </div>
        </FormDiv>
        <ButtonDiv>
          <div className={'formatButton'}>
            <Button onClick={handlerEnviar}>
              <div>Enviar</div>
            </Button>
            <CancelButton onClick={handlerClose}>
              <div>Cancelar</div>
            </CancelButton>
          </div>
        </ButtonDiv>
      </Content>
    </Background>
  );
}

export default ClaimPayment;
